module.exports = __webpack_public_path__ + "static/media/correct.82cac38d.png";